// #205 B5 — el bloque «Precio mensual» del detalle de cliente. Lo ven el admin
// (precio estimado) y el reseller (su costo por ese cliente, con su descuento
// ya aplicado: el backend calcula monthly_price con el descuento del reseller
// del cliente). Operador y cliente no lo ven.
export function MonthlyPriceCard({ client, isAdmin, isReseller }) {
  if (!(isAdmin || isReseller) || client.internal || !client.monthly_price) return null;
  const title = isReseller && !isAdmin
    ? 'Tu costo mensual por este cliente (con tu descuento aplicado)'
    : 'Precio Mensual Estimado';
  return (
    <div style={{
      background: 'var(--surface)', border: '1px solid var(--border)',
      padding: 20, marginBottom: 20,
    }}>
      <div style={{
        fontSize: 10, letterSpacing: 2, color: 'var(--muted)',
        fontFamily: 'var(--mono)', textTransform: 'uppercase', marginBottom: 16,
      }}>
        {title}
      </div>
      {(() => {
        const mp = client.monthly_price;
        const fmt = n => `$${(Number(n) || 0).toFixed(2)}`;
        const rows = [
          [`Piso (incluye ${mp.included_storage_gb} GB + ${mp.included_servers} srv)`, '', fmt(mp.base_price)],
          ...((mp.tier_breakdown || []).map(t => ([
            `Storage ${t.from_gb}–${t.to_gb ?? '∞'} GB`,
            `${t.gb} GB × $${t.price_per_gb}/GB`,
            fmt(t.cost),
          ]))),
          ...(mp.extra_servers > 0
            ? [[`${mp.extra_servers} servidor${mp.extra_servers !== 1 ? 'es' : ''} extra`, `× $${mp.price_per_server}/srv`, fmt(mp.server_cost)]]
            : []),
          ...(mp.covert_copy
            ? [['Covert Copy', `fijo $${fmt(mp.covert_copy_base_fee)} + $${fmt(mp.covert_copy_variable_cost)} (${mp.covert_copy_gb} GB)`, fmt(mp.covert_copy_cost)]]
            : []),
          ...(mp.cloud_users_count > 0
            ? [[`${mp.cloud_users_count} usuario${mp.cloud_users_count !== 1 ? 's' : ''} cloud`, `× $${mp.price_per_cloud_user}/u`, fmt(mp.cloud_user_cost)]]
            : []),
        ];
        return (
          <>
            {rows.map(([label, unit, amount], i) => (
              <div key={i} style={{
                display: 'flex', justifyContent: 'space-between',
                fontSize: 13, marginBottom: 8, paddingBottom: 8,
                borderBottom: '1px solid var(--border)',
              }}>
                <span>{label}</span>
                <span style={{ color: 'var(--muted)', fontSize: 11 }}>{unit}</span>
                <span style={{ fontFamily: 'var(--mono)', color: 'var(--accent)' }}>{amount}</span>
              </div>
            ))}
            {mp.cloud_users_count > 0 && (
              <div style={{
                display: 'flex', justifyContent: 'space-between',
                fontSize: 13, marginBottom: 8, paddingBottom: 8,
                borderBottom: '1px solid var(--border)',
              }}>
                <span>Usuarios cloud ({mp.cloud_users_count})</span>
                <span style={{ color: 'var(--muted)', fontSize: 11 }}>× ${mp.price_per_cloud_user}/usuario</span>
                <span style={{ fontFamily: 'var(--mono)', color: 'var(--accent)' }}>${mp.cloud_user_cost.toFixed(2)}</span>
              </div>
            )}
            {mp.discount_pct > 0 && (
              <div style={{
                display: 'flex', justifyContent: 'space-between',
                fontSize: 13, marginBottom: 8, paddingBottom: 8,
                borderBottom: '1px solid var(--border)',
                color: 'var(--warning)',
              }}>
                <span>Descuento reseller</span>
                <span style={{ color: 'var(--muted)', fontSize: 11 }}>{mp.discount_pct}%</span>
                <span style={{ fontFamily: 'var(--mono)' }}>-${mp.discount_amount.toFixed(2)}</span>
              </div>
            )}
            <div style={{
              display: 'flex', justifyContent: 'space-between',
              fontSize: 15, fontWeight: 700, marginTop: 8, paddingTop: 4,
            }}>
              <span>TOTAL</span>
              <span style={{ fontFamily: 'var(--mono)', color: 'var(--green)' }}>
                ${mp.total.toFixed(2)}/mes
              </span>
            </div>
          </>
        );
      })()}
    </div>
  );
}

// Suma de monthly_price.total de una lista de clientes (tarjeta del tablero del reseller).
export function sumMonthlyTotals(clients) {
  return (clients || []).reduce((acc, c) => acc + (Number(c.monthly_price?.total) || 0), 0);
}
